import { IGeocodeUndergroundSchema } from '../../../repositories/monolith-python/v2/geocode';
import { IOfferUnderground } from '../../../types/reducers/offer';

export const mapUnderground = (undergroundRaw: IGeocodeUndergroundSchema): IOfferUnderground => {
  const { id, name, color, time, timeByCar, timeByWalk, transportId } = undergroundRaw;

  return {
    id,
    name,
    color: color || null,
    time: time || null,
    timeByCar: timeByCar || null,
    timeByWalk: timeByWalk || null,
    transportId: transportId || null,
  };
};
